<script>
import Layout from "../../_layouts/main";
import PageHeader from "@/components/page-header";
import List from '../../../components/user/list'

/**
 * Dashboard Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    List
  },
  data() {
    return {
      title: "회원목록(정상)",
      state: ''
    };
  },
  mounted() {
    this.state = this.$route.params.state
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <List :state="state" />
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
